import React, {PropsWithChildren, ReactElement} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize, flex, p, w100} from "@pg-design/helpers-css";

import {IReelSize} from "../../../types/IReelSize";

interface IProps extends PropsWithChildren {
    cover: ReactElement;
    logo: ReactElement;
    size: IReelSize;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    onClick?: () => void;
    className?: string;
}

export const ReelBox = (props: IProps) => {
    return (
        <Wrapper size={props.size} onClick={props.onClick} onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave} className={props.className}>
            <div css={coverWrapperStyle}>{props.cover}</div>
            <div css={logoWrapperStyle}>{props.logo}</div>
            <div css={aplaStyle}>
                <div css={[p(1), w100]}>{props.children}</div>
            </div>
        </Wrapper>
    );
};

const getReelWrapperDimensionsBySize = (size: IReelSize) => {
    switch (size) {
        case "S":
            return {
                width: "12.6rem",
                height: "22.5rem"
            };
        case "M":
            return {
                width: "16.8rem",
                height: "30rem"
            };
        case "L":
            return {
                width: "26.4rem",
                height: "47rem"
            };
        case "XL":
            return {
                width: "33.6rem",
                height: "60rem"
            };
        default: {
            return {
                width: "100%",
                height: "100%"
            };
        }
    }
};

const Wrapper = styled.div<{size: IReelSize}>`
    position: relative;
    ${borderRadius(2)};
    overflow: hidden;
    background-color: #fff;
    ${elevation(1)};

    ${({size}) => {
        const {width, height} = getReelWrapperDimensionsBySize(size);

        return css`
            width: ${width};
            height: ${height};
        `;
    }};
`;

const coverWrapperStyle = css`
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
`;

const logoWrapperStyle = css`
    position: absolute;
    top: ${calculateRemSize(1)};
    right: ${calculateRemSize(1)};

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

const aplaStyle = css`
    ${flex("flex-end")};
    position: absolute;
    overflow: hidden;
    inset: auto 0 0 0;
    height: 18rem;
    background: linear-gradient(rgba(255, 255, 255, 0), rgba(35, 35, 45, 1));
`;
import React, {PropsWithChildren, ReactElement} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize, flex, p, w100} from "@pg-design/helpers-css";

import {IReelSize} from "../../../types/IReelSize";

interface IProps extends PropsWithChildren {
    cover: ReactElement;
    logo: ReactElement;
    size: IReelSize;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    onClick?: () => void;
    className?: string;
}

export const ReelBox = (props: IProps) => {
    return (
        <Wrapper size={props.size} onClick={props.onClick} onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave} className={props.className}>
            <div css={coverWrapperStyle}>{props.cover}</div>
            <div css={logoWrapperStyle}>{props.logo}</div>
            <div css={aplaStyle}>
                <div css={[p(1), w100]}>{props.children}</div>
            </div>
        </Wrapper>
    );
};

const getReelWrapperDimensionsBySize = (size: IReelSize) => {
    switch (size) {
        case "S":
            return {
                width: "12.6rem",
                height: "22.5rem"
            };
        case "M":
            return {
                width: "16.8rem",
                height: "30rem"
            };
        case "L":
            return {
                width: "26.4rem",
                height: "47rem"
            };
        case "XL":
            return {
                width: "33.6rem",
                height: "60rem"
            };
        default: {
            return {
                width: "100%",
                height: "100%"
            };
        }
    }
};

const Wrapper = styled.div<{size: IReelSize}>`
    position: relative;
    ${borderRadius(2)};
    overflow: hidden;
    background-color: #fff;
    ${elevation(1)};

    ${({size}) => {
        const {width, height} = getReelWrapperDimensionsBySize(size);

        return css`
            width: ${width};
            height: ${height};
        `;
    }};
`;

const coverWrapperStyle = css`
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
`;

const logoWrapperStyle = css`
    position: absolute;
    top: ${calculateRemSize(1)};
    right: ${calculateRemSize(1)};

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

const aplaStyle = css`
    ${flex("flex-end")};
    position: absolute;
    overflow: hidden;
    inset: auto 0 0 0;
    height: 18rem;
    background: linear-gradient(rgba(255, 255, 255, 0), rgba(35, 35, 45, 1));
`;
